'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Tooltip, TooltipProvider } from '../../components/overlays/tooltip/index.js';
/**
 * A button that can carry a tooltip and still be used as another primitive's
 * `asChild` trigger (a popover or menu): every prop and the ref reach the
 * `<button>`, and the tooltip wraps it with its own provider.
 */
export const TipButton = forwardRef(function TipButton({ tip, tipSide = 'right', type = 'button', ...props }, ref) {
    const button = _jsx("button", { ref: ref, type: type, ...props });
    if (!tip)
        return button;
    return (_jsx(TooltipProvider, { delayDuration: 100, children: _jsx(Tooltip, { content: tip, side: tipSide, children: button }) }));
});
//# sourceMappingURL=tip-button.js.map